<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por placa ou renavam">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline nowrap" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges" :filters="badgesFilters" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="vehicle-account">Conta</label>
          <Select2 :options="filterAccount" v-model="query.accountId" id="vehicle-account"
            title-load="Carregando contas..." />
        </div>

        <div class="col-md-4">
          <label for="vehicle-subscription-type">Status da conta</label>
          <select v-model="query.subscriptionType" id="vehicle-subscription-type" class="browser-default custom-select">
            <option v-for="opt in (filterSubscriptionType ? filterSubscriptionType.table : [])" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="vehicle-entity-status">Status do Veículo</label>
          <select v-model="query.entityStatusId" id="vehicle-entity-status" class="browser-default custom-select">
            <option v-for="opt in (filterEntityStatusId ? filterEntityStatusId.table : [])" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="vehicle-city-code">Cidade</label>
          <Select2 v-model="query.cityCode" id="vehicle-city-code" :options="filterCityCode" />
        </div>

        <div class="col-md-4">
          <label for="vehicle-uf">UF</label>
          <Select2 v-model="query.uf" id="vehicle-uf" :options="filterUF" />
        </div>

        <div class="col-md-4">
          <label for="vehicle-service">Serviço</label>
          <Select2 v-model="query.scrapingServiceName" id="vehicle-service" :options="filterServiceNames" />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="form-control">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="exportReport" :disabled="disabledReport">
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <button class="btn btn-outline ml-3 mb-1" v-if="vehicles.length > 0" @click="changeCheckAll"
          :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todos' : 'Desmarcar todos' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

        <button v-if="isBrobotStaff" class="btn btn-primary ml-3 mb-1" :disabled="!!bulkBlockedReason"
          :title="bulkBlockedReason" @click="showBulkServices = true">
          Editar serviços ({{ checkedVehicles.length }})
        </button>

        <small v-if="bulkBlockedReason && checkedVehicles.length > 0" class="ml-2 text-muted">
          {{ bulkBlockedReason }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-sm-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow" />
              </th>
              <th>ID</th>
              <th>Placa</th>
              <th>Chassi</th>
              <th>Renavam</th>
              <th>CPF/CNPJ</th>
              <th>Código de segurança</th>
              <th>UF</th>
              <th>Conta</th>
              <th>Status da conta</th>
              <th>Serviços</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th>Status do veículo</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vehicle in vehicles" :key="vehicle.id">
              <td>
                <BkpsCheckBox v-model="vehicle.checked" @input="changeCheckRow" />
              </td>
              <td>{{ vehicle.id }}</td>
              <td>{{ vehicle.plate || '-' }}</td>
              <td>{{ vehicle.chassi || '-' }}</td>
              <td>{{ vehicle.renavam || '-' }}</td>
              <td>{{ $options.filters.cpfCnpj(vehicle.cpfCnpj) || '-' }}</td>
              <td>{{ vehicle.securityCode || '-' }}</td>
              <td>{{ vehicle.uf || '-' }}</td>
              <td>{{ getAccountName(vehicle) }}</td>
              <td>
                <span v-if="vehicle.accountSubscriptionType && translateAccountStatus(vehicle.accountSubscriptionType) !== '-'"
                  class="badge" :class="accountStatusBadgeClass(vehicle.accountSubscriptionType)">
                  {{ translateAccountStatus(vehicle.accountSubscriptionType) }}
                </span>
                <template v-else>—</template>
              </td>
              <td><ServicesCell :services="vehicleServiceNames(vehicle)" /></td>
              <td>{{ vehicle.createdBy || '-' }}</td>
              <td>{{ vehicle.updatedBy || '-' }}</td>
              <td>{{ (vehicle.entityStatus && vehicle.entityStatus.friendlyName) || '-' }}</td>
              <td>{{ vehicle.createdAt | datetime }}</td>
              <td>{{ vehicle.updatedAt | datetime }}</td>
              <td>
                <button @click="showVehicle(vehicle)" class="btn btn-outline">Detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
              @pagination="pagination" />
          </div>
        </div>
      </div>

      <ShowDataModal v-if="currentVehicle" v-model="showModal" :header="currentVehicle.plate" :data="currentVehicle"
        :deep="3" />

      <BulkServicesModal v-if="bulkAccountId" v-model="showBulkServices" :account-id="bulkAccountId"
        :account-name="getAccountName(checkedVehicles[0])" :scraping-services="scrapingServices"
        :vehicles="checkedVehicles" @applied="find()" />
    </div>
  </div>

</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import BulkServicesModal from '@/components/admin/vehicles/BulkServicesModal'
import CheckedModels from '@/mixins/CheckedModels'
import GetUser from '@/mixins/GetUser'
import EntityProxy from '@/models/EntityProxy'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ServicesCell from '@/components/admin/vehicles/ServicesCell'
import ShowDataModal from '@/components/admin/ShowDataModal'
import { ACCOUNT_STATUS_OPTIONS, accountStatusBadgeClass, translateAccountStatus } from '@/utils/accountStatus'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'
import { IBGE } from '@/models/ibge'

export default {
  components: { BadgeFilters, BkpsCheckBox, BulkServicesModal, ChevronDownIcon, Pagination, SearchIcon, Select2, ServicesCell, ShowDataModal },
  computed: {
    badgesFilters() {
      return [
        this.filterAccount, this.filterSubscriptionType, this.filterEndDate, this.filterStartDate,
        this.filterUF, this.filterCityCode, this.filterEntityStatusId, this.filterServiceNames
      ]
    },
    vehicles() {
      return this.getModels || []
    },
    checkedVehicles() {
      return this.vehicles.filter(v => v.checked)
    },
    /**
     * Editar serviço é privilégio da equipe Brobot — mesma lista de
     * Shared::CheckServicesPermission na API. Quem não passa por ela leva 403 no
     * lote inteiro, então a tela não oferece o botão.
     */
    isBrobotStaff() {
      const email = (this.getUser && this.getUser.email) || ''
      return email.endsWith('@brobot.com.br') ||
        email.endsWith('@brobotbr.com.br') ||
        email === 'administrador@multas.awsapps.com'
    },
    /**
     * A listagem é cross-conta e o serviço é gravado por conta, então o lote só
     * existe quando a seleção inteira pertence a UMA conta.
     */
    bulkAccountId() {
      const ids = [...new Set(this.checkedVehicles.map(v => v.accountId))]
      return ids.length === 1 ? ids[0] : null
    },
    bulkBlockedReason() {
      if (this.checkAll)
        return 'Marque os veículos explicitamente — "selecionar todos" não carrega as linhas das outras páginas'
      if (this.checkedVehicles.length === 0)
        return 'Selecione ao menos um veículo'
      if (!this.bulkAccountId) {
        const total = [...new Set(this.checkedVehicles.map(v => v.accountId))].length
        return `A seleção mistura ${total} contas — os serviços são gravados por conta`
      }
      return null
    },
    disabledReport() {
      return this.meta.totalCount === 0 || (!this.checkAll && !this.vehicles.some(v => v.checked))
    },
    filterCityCode() {
      const uf = this.query.uf
      let table = null

      if (Array.isArray(uf) && uf.length > 0) {
        table = IBGE.table
          .filter(city => uf.includes(city.initials))
          .map(city => ({
            label: `${city.name} - ${city.initials}`,
            value: city.cityCode
          }))
      } else {
        table = IBGE.table.map(city => ({
          label: `${city.name} - ${city.initials}`,
          value: city.cityCode
        }))
      }

      return new Filter({
        key: 'cityCode',
        label: 'Código',
        table: table
      })
    },
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.order.push('updated_at', 'desc')
    this.$set(this.query, 'periodType', 'created_at')
    this.$set(this.query, 'entityStatusId', '')
    this.$set(this.query, 'subscriptionType', '')
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    this.loadEntityStatusFilter()
    this.buildFilterSubscriptionType()
    this.fetchScrapingServices()

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentVehicle: null,
    filterAccount: null,
    filterEntityStatusId: null,
    filterServiceNames: null,
    filterSubscriptionType: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterUF: new Filter({
      key: 'uf',
      label: 'UF',
      table: [...new Set(IBGE.table.map(city => city.initials))].sort()
    }),
    modelPathPrefix: 'admin',
    nameModel: 'Vehicle',
    orderBy: 'updated_at',
    scrapingServices: [],
    serviceNameMap: {},
    showBulkServices: false,
    showModal: false,
  }),
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    accountStatusBadgeClass,
    translateAccountStatus,
    buildFilterSubscriptionType() {
      this.filterSubscriptionType = new Filter({
        key: 'subscriptionType',
        label: 'Status da conta',
        type: 'select',
        table: [['Todos', ''], ...ACCOUNT_STATUS_OPTIONS.map(o => [o.label, o.value])]
      })
    },
    buildFilterServiceNames(services) {
      this.scrapingServices = services
      this.serviceNameMap = services.reduce((acc, s) => {
        acc[s.name] = s.friendlyName
        return acc
      }, {})

      this.filterServiceNames = new Filter({
        key: 'scrapingServiceName',
        label: 'Serviço',
        table: services.map(s => [
          `${s.friendlyName} (${s.appName}) (${s.enable ? 'Ativo' : 'Inativo'})`,
          s.name
        ])
      })
    },
    vehicleServiceNames(vehicle) {
      const services = vehicle.services || {}
      return Object.keys(services)
        .filter(name => services[name] && services[name].enable)
        .map(name => this.serviceNameMap[name] || name)
        .sort()
    },
    fetchScrapingServices() {
      const key = 'scrapingServiceToAdmin'
      const data = this.$ls.get(key)

      if (data) {
        this.buildFilterServiceNames(EntityProxy.build(data))
        return
      }

      return this.axios.get('maestro/scraping_services', { params: { meta: false, per_page: 10000 } })
        .then(response => EntityProxy.build(response.data))
        .then(services => {
          this.$ls.set(key, services, { minutes: 5 })
          this.buildFilterServiceNames(services)
        })
        .catch(e => this.$notify.addError(e))
    },
    loadEntityStatusFilter() {
      this.axios.v3.get('admin/entity_statuses', { params: { per_page: 1000 } })
        .then(response => {
          const table = [
            ['Todos', ''],
            ...(response.data || [])
              .filter(es => es.friendly_name)
              .map(es => [es.friendly_name, es.id])
          ]

          this.filterEntityStatusId = new Filter({
            key: 'entityStatusId',
            label: 'Status',
            type: 'select',
            table
          })
        })
        .catch(e => this.$notify.addError(e))
    },
    changeCheckAll() {
      this.changeCheck({ checkAll: !this.checkAll, sources: this.vehicles })
    },
    changeCheckAllRow(value) {
      this.changeCheck({ checkAllRow: value, sources: this.vehicles })
    },
    changeCheckRow() {
      this.changeCheck({ sources: this.vehicles })
    },
    exportReport() {
      let params
      let amount

      if (this.checkAll) {
        params = this.buildParams()
        amount = this.meta.totalCount
      } else {
        const ids = this.vehicles.filter(v => v.checked).map(v => v.id)
        params = { q: { id: ids } }
        amount = ids.length
      }

      if (!confirm(`Exportar ${amount} Veículo(s).\nTem certeza?`))
        return

      this.openGlobalLoad()
      this.axios.get('admin/vehicles/report', { params })
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data)
          else
            this.$notify.add(response.meta.notice)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    find() {
      this.asyncTemplateSelect()
    },
    showVehicle(vehicle) {
      this.currentVehicle = vehicle
      this.showModal = true
    }
  },
  mixins: [CheckedModels, GetUser, ModelMapper],
  name: 'Vehicle',
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      }
    },
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped>
  .badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
    white-space: nowrap;
  }
  .badge-success { background-color: #28a745; }
  .badge-warning { background-color: #FFC866; color: #051B30; }
  .badge-danger { background-color: #dc3545; }
  .badge-info { background-color: #318BE3; }
  .badge-secondary { background-color: #6c757d; }
</style>
